import classNames from "classnames";
import React, { ElementType } from "react";
import styles from "./loading-skeleton.module.scss";

export function LoadingSkeleton(props: Props) {
  const Container = props.component ?? "div";
  return (
    <Container
      title="loading"
      className={classNames(props.className, styles["skeleton"])}
      style={props.style}
    ></Container>
  );
}

interface Props extends React.HTMLProps<HTMLDivElement> {
  style?: React.CSSProperties;
  component?: ElementType;
}
